<script setup lang="ts">
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
</script>

<template>
  <ButtonComponent class="bg-primary text-white">
    <slot/>
  </ButtonComponent>
</template>

<style scoped>
  .active {
    @apply bg-red-500;
  }

  *[disabled] {
    @apply bg-grey-light;
  }

  *:not([disabled]) {
    @apply hover:bg-grey-light;
  }
</style>
